import CookiesPolicyModal from './CookiesPolicyModal';
export default CookiesPolicyModal;
